interface NavigationBarProps {
  title: string;
  leftAction?: React.ReactNode;
  rightAction?: React.ReactNode;
  largeTitle?: boolean;
}

export function NavigationBar({
  title,
  leftAction,
  rightAction,
  largeTitle = false,
}: NavigationBarProps) {
  return (
    <>
      {/* Spacer to push content below the fixed header */}
      <div 
        aria-hidden="true"
        style={{
          height: largeTitle
            ? 'calc(env(safe-area-inset-top) + 96px)'
            : 'calc(env(safe-area-inset-top) + 44px)',
        }}
      />
      
      <header className="fixed top-0 left-0 right-0 z-40 bg-background border-b border-[var(--color-ios-separator)]">
        <div className="pt-safe">
          <div className="flex items-center justify-between h-11 px-4">
            <div className="w-20 flex justify-start">
              {leftAction}
            </div>
            {!largeTitle && (
              <h1 className="text-[17px] leading-[22px] font-semibold truncate">
                {title}
              </h1>
            )}
            <div className="w-20 flex justify-end">
              {rightAction}
            </div>
          </div>
          {largeTitle && (
            <div className="px-4 pb-2">
              <h1 className="text-[34px] leading-[41px] font-bold">{title}</h1>
            </div>
          )}
        </div>
      </header>
    </>
  );
}
